
import React, { useMemo, useState } from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import products from "../../data/products.json";
import { useLanguage } from "../../context/LanguageContext";

export const Selling = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const firstProduct = products[0];

  const [selectedProductId, setSelectedProductId] = useState<string>(
    firstProduct?.id || ""
  );

  const [selectedImage, setSelectedImage] = useState<string | null>(
    firstProduct?.image?.[0] || null
  );

  const selectedProduct = useMemo(
    () => products.find((p) => p.id === selectedProductId) || firstProduct,
    [selectedProductId, firstProduct]
  );

  const handleImageClick = (productId: string, image: string) => {
    setSelectedProductId(productId);
    setSelectedImage(image);
  };

  return (
    <div className="selling-page-shell">
      <div className="selling-ambient selling-ambient-one"></div>
      <div className="selling-ambient selling-ambient-two"></div>
      <div className="selling-light-beam"></div>
      <div className="selling-blue-diamond"></div>
      <div className="selling-outline selling-outline-one"></div>
      <div className="selling-outline selling-outline-two"></div>
      <div className="selling-dots"></div>

      <button className="selling-back-button" onClick={() => navigate(-1)}>

      </button>

      <main className="selling-overview-layout">
        <section className="selling-gallery-card">
          <div className="selling-gallery-header">
            <span className="selling-mini-label">Smart BAG</span>
            <h1>{selectedProduct?.name || "Smart BAG"}</h1>
            <p>{t("select_brand_model_help")}</p>
          </div>

          <div className="galleryimages selling-gallery-premium">
            <div className="thumbnails">
              {products.map((product) => {
                const thumb = product.image?.[0];

                if (!thumb) return null;

                return (
                  <button
                    key={product.id}
                    className={`thumbnail-button ${
                      selectedProductId === product.id ? "selected" : ""
                    }`}
                    onClick={() => handleImageClick(product.id, thumb)}
                    aria-label={`${t("thumbnail")} ${product.id}`}
                  >
                    <img
                      src={thumb}
                      alt={`${t("thumbnail")} ${product.id}`}
                      className="thumbnail"
                    />
                  </button>
                );
              })}
            </div>

            <div className="prodcustimagesdiv">
              <div className="product-stage-platform"></div>

              {selectedImage && (
                <img
                  src={selectedImage}
                  alt={t("main_image")}
                  className="mainimage"
                />
              )}
            </div>
          </div>
        </section>

        <aside className="sellinginfodiv overview-info-card">
          <div className="productinfo">
            <span className="product-category-pill">Premium filtration</span>

            <h2 className="product-title">
              {selectedProduct?.name || "Smart BAG"}
            </h2>

            <div className="selling-feature-list">
              <div className="selling-feature-item">
                <img src="/layers.png" alt="" />
                <div>
                  <strong>4 շերտանոց պաշտպանություն</strong>
                  <span>Ամուր և հուսալի կառուցվածք</span>
                </div>
              </div>

              <div className="selling-feature-item">
                <img src="/vacuum_cleaner_icon.png" alt="" />
                <div>
                  <strong>Մաքուր օդ և ուժեղ ֆիլտրացիա</strong>
                  <span>Նախատեսված է ամենօրյա օգտագործման համար</span>
                </div>
              </div>

              <div className="selling-feature-item">
                <img src="/info.png" alt="" />
                <div>
                  <strong>Համատեղելի մոդելների հետ</strong>
                  <span>Տեսեք ամբողջական տեղեկությունը</span>
                </div>
              </div>
            </div>

            {selectedProduct && (
              <Link
                to={`/selling/${selectedProduct.id}`}
                className="buybutton premium-main-link"
              >
                {t("view_details")}
              </Link>
            )}
          </div>
        </aside>
      </main>
    </div>
  );
};

